var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container container--full-width-on-mobile dashboard-quota"},[_c('h1',{staticClass:"dashboard-quota__header"},[_vm._v(_vm._s(_vm.$t('ctx.quotas.header')))]),_c('c-quota-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }